import React from 'react'
import { useTranslation } from 'react-i18next'
import cl from 'classnames'

import { getCurrentYear } from 'Shared/utils'

import { COPYRIGHT_LINK, TERMS_CONDITIONS_LINK } from 'Core/constants'

import { BrandFooterProps } from './types'

import styles from './styles.module.scss'

const BrandFooter: React.FC<BrandFooterProps> = ({ wrapperClassName }) => {
	const { t } = useTranslation()

	return (
		<div className={cl(styles.wrapper, wrapperClassName)}>
			<ul className={styles.menu}>
				<li>
					<a href={TERMS_CONDITIONS_LINK}>{t('core:labels.termsAndConditions')}</a>
				</li>
				<li>
					<a href={COPYRIGHT_LINK}> {t('core:labels.privacy')}</a>
				</li>
			</ul>
			<span className={styles.copyright}>©{getCurrentYear()} Envita Solutions, LLC</span>
		</div>
	)
}

export default React.memo(BrandFooter)
